import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import i18next from 'i18next';

import { toDisplayDecimal } from '../../utils';
import styles from '../../styles/bankBalance.module.css';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    divList: {
        paddingTop: '5px',
    },
    spanNewRow: {
        display: 'table'
    },
    spanLabel: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    spanValue: {
        marginLeft: '5px',
        fontSize: '14px'
    }
}));

export default function BankProvisionalSummary(props) {

    const classes = useStyles();
    const [dataBank, setDataBank] = React.useState(null);
    const [typeEntry, setTypeEntry] = React.useState('unit');

    const { data } = props;

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        setDataBank(data);
        const type = data[0].bankType === 'M' ? "Amount" : "Unit";
        setTypeEntry(type);
    }

    return (
        <div id="divBankProvisionalSummary" className={styles.rootPayBank}>
            <div className={styles.konekCard}>
                <div className={classes.divList}>
                    {dataBank != null && dataBank.map((obj, index) =>
                        <React.Fragment key={index}>
                            <ListItem key={index} className="listItem">
                                <ListItemText primary={
                                    <React.Fragment>
                                        <div>
                                            <span className={classes.spanLabel}>{i18next.t(`bankBalance:form.approved${typeEntry}`)}{i18next.t('common:labelSeparator')}</span>
                                            <span className={classes.spanValue}>{toDisplayDecimal(parseFloat(obj.approvedUnit))}</span>
                                        </div>

                                        <div>
                                            <span className={classes.spanLabel}>{i18next.t(`bankBalance:form.requested${typeEntry}`)}{i18next.t('common:labelSeparator')}</span>
                                            <span className={classes.spanValue}>{toDisplayDecimal(parseFloat(obj.requestedUnit))}</span>
                                        </div>

                                        <div>
                                            <span className={classes.spanLabel}>{i18next.t(`bankBalance:form.provisionalUnitBalance`)}{i18next.t('common:labelSeparator')}</span>
                                            <span className={classes.spanValue}>{toDisplayDecimal(parseFloat(obj.provisionalUnitBalance))}</span>
                                        </div>
                                    </React.Fragment>
                                } />
                            </ListItem>
                        </React.Fragment>
                    )}
                </div>
            </div>
        </div>
    );
}